module.exports = __webpack_public_path__ + "img/Kronberg_BRELG167.9d9a4f53.png";